module.exports = __webpack_public_path__ + "img/user.2eb7377d.png";